// extracted by mini-css-extract-plugin
module.exports = {"whereToGoButton":"WhereToGoButton_whereToGoButton__yVtmP","starsIcon":"WhereToGoButton_starsIcon__kY6O3"};